// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Countries from "../Restaumatic.Countries/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Countries.eqCountry);
var countryIsSymbol = {
    reflectSymbol: function () {
        return "country";
    }
};
var phoneIsSymbol = {
    reflectSymbol: function () {
        return "phone";
    }
};
var ValidatePhoneNumberRequestIsSymbol = {
    reflectSymbol: function () {
        return "ValidatePhoneNumberRequest";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var ValidatePhoneNumberRequest = function (x) {
    return x;
};
var toFillFormTypeValidatePho = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesValidatePhoneNumb = {};
var rPCMethodNameValidatePhon = {
    rpcMethodName: function (v) {
        return "ValidatePhoneNumberRequest";
    }
};
var newtypeValidatePhoneNumbe = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldValidatePhoneNumb = function (dictHasField) {
    return dictHasField;
};
var eqValidatePhoneNumberRequ = {
    eq: function (x) {
        return function (y) {
            return eq(x.country)(y.country) && x.phone === y.phone;
        };
    }
};
var genericValidatePhoneNumberRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showValidatePhoneNumberRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericValidatePhoneNumberRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(countryIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(phoneIsSymbol)(Data_Show.showString))(Restaumatic_Countries.showCountry))))(ValidatePhoneNumberRequestIsSymbol))
};
var unscrambleDecodeValidatePhoneNumberRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericValidatePhoneNumberRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(countryIsSymbol)(Restaumatic_Countries.unscrambleDecodeCountry)(/* #__PURE__ */ Unscramble.decodeRecordCons(phoneIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeValidatePhoneNumberRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericValidatePhoneNumberRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ValidatePhoneNumberRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(phoneIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Countries.encodeCountry))))))
};
var decodeValidatePhoneNumberRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericValidatePhoneNumberRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ValidatePhoneNumberRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(phoneIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Countries.decodeCountry))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ValidatePhoneNumberRequest,
    genericValidatePhoneNumberRequest,
    eqValidatePhoneNumberRequ,
    showValidatePhoneNumberRequest,
    rPCMethodNameValidatePhon,
    rPCSitesValidatePhoneNumb,
    encodeValidatePhoneNumberRequest,
    decodeValidatePhoneNumberRequest,
    unscrambleDecodeValidatePhoneNumberRequest,
    toFillFormTypeValidatePho,
    hasFieldValidatePhoneNumb,
    newtypeValidatePhoneNumbe
};
